import { AuthGuard, CrudOp, projectOverviewAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const ProjectManagementView: FC = () => (
  <AuthGuard authScope={projectOverviewAuthScope} crudOp={CrudOp.READ}>
    <Suspense><LazyProjectManagementView/></Suspense>
  </AuthGuard>
);

const LazyProjectManagementView = lazy(importView(
  () => import("../components/ProjectManagementView"),
  (it) => it.ProjectManagementView,
));
